<template>
  <div v-bind:class="{ 'modal': true, 'is-active': isExpanded }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">新しいデバイスを追加する</p>
        <button @click="cancel" class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <p>デバイスは2台まで登録できます</p>
        <div class="field">
          <label for="device-name">デバイス名</label>
          <div class="control">
            <input v-model="deviceName" class="input" name="device-name" type="text">
          </div>
        </div>
        <div class="field">
          <label for="device-kind">デバイスの種類</label>
          <div class="control">
            <div class="select">
              <select v-model="deviceKind" name="device-kind">
                <option value="" selected>選択してください</option>
                <option value="motchd">motch daemon</option>
                <option value="esp8266">ESP8266 with Arduino</option>
                <option value="esp32">ESP32 with Arduino</option>
                <option value="wiolte">WioLTE for Arduino</option>
              </select>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button @click="submit" class="button is-primary">デバイスを追加する</button>
        <button @click="cancel" class="button">キャンセル</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { DevicesRepository } from '@/repository/DevicesRepository';

export default {
  props: [
    //'networkId',
    'isExpanded',
  ],
  data: function() {
    return {
      deviceName: '',
      deviceKind: '',
    }
  },
  methods: {
    submit: function() {
      DevicesRepository.create(this.deviceName, this.deviceKind);//, this.networkId);
      this.$emit('device-add', { name: this.deviceName, kind: this.deviceKind });
      this.deviceName = '';
      this.deviceKind = '';
    },
    cancel: function() {
      this.deviceName = '';
      this.deviceKind = '';
      this.$emit('cancel');
    },
  }
}
</script>